import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api
      .post("/auth/google/session", null, { headers: { "X-Session-ID": sessionId } })
      .then(({ data }) => {
        setUser(data);
        navigate("/admin", { replace: true, state: { user: data } });
      })
      .catch((e) => {
        setUser(false);
        navigate("/admin/login", { replace: true, state: { error: formatApiError(e) } });
      });
  }, [location.hash, navigate, setUser]);

  return <div className="min-h-screen bg-obsidian" data-testid="auth-callback" />;
}
